import * as React from "react";
import {HomeInsights} from "./HomeInsights";
import {HomeSharedDocuments} from "./HomeSharedDocuments";
import {HomeResearch} from "./HomeResearch";
import {hasConsultantLevelAccess, hasResearchPageAccess} from "../../utils/sessionUtil";
import {CprPortfolioOverview} from "./CprPortfolioOverview";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";
import {HomeAssetTrends} from "./HomeAssetTrends";

export interface IHomeProps {
    insightsEnabled: boolean;
    sharedDocumentsEnabled: boolean;
    hasResearchAccess: boolean;
    hasPortfolioAccess: boolean;
    clientPortfolioEnabled: boolean;
    currentPlan: IPlanInfo;
    clientPerformanceReportingAccess: boolean;
    cprPortfolioOverviewEnabled: boolean;
}

export const Home: React.FunctionComponent<IHomeProps> = (props) => {
    const renderCprPortfolioOverview = () => {
        return props.currentPlan.powerbiId
            ? <CprPortfolioOverview
                clientPerformanceReportingAccess={props.clientPerformanceReportingAccess}
                cprPortfolioOverviewEnabled={props.cprPortfolioOverviewEnabled}
            />
            : null;
    };

    const renderAssetTrends = () => {
        return (props.hasPortfolioAccess && (hasConsultantLevelAccess() || props.clientPortfolioEnabled))
            ? <HomeAssetTrends />
            : null;
    };

    return <div className="new-common-styles page-min-width-1024 home__container" data-testid="home__container">
        {renderAssetTrends()}
        {renderCprPortfolioOverview()}
        {props.insightsEnabled && <HomeInsights/>}
        <div className="home__documents-research-container">
            {props.sharedDocumentsEnabled && <HomeSharedDocuments/>}
            {hasResearchPageAccess(props.hasResearchAccess, props.hasPortfolioAccess, props.clientPortfolioEnabled)
                && <HomeResearch/>}
        </div>
    </div>;
};
